export default {
  AM: 'AM',
  PM: 'PM',
};
